import React, { Component } from 'react';
import clsx from 'clsx'
import LocaleLink from '../../Routes/LocaleLink'


class TinyJobCard extends Component{

    handleTextLength(text) {
        if(text){
            if(window.innerWidth < 1200){
                return text.length > 60 ? text.substring(0, 59) + '...' : text
            } else {
                return text.length > 75 ? text.substring(0, 74) + '...' : text
            }
        }
    }

    render() {
        const {offer} = this.props;
        if (!offer) return null;

        return(
            <>
                <LocaleLink to={"/jobs/" + offer.business_unit + '/' + offer.slug} className={clsx("job-info", "job-info-tiny", this.props.className)}>
                    <div className="job-title">
                        <h4 title={offer.title}>
                            {offer.title}
                        </h4>
                        { offer.address ?
                            <span>{offer.address.city}, {offer.address.country.name}</span>
                            : null
                        }
                    </div>
                    <div className="job-desc-text">
                        <p>
                            {this.handleTextLength(offer.hat)}
                        </p>
                    </div>
                    <ul className="tech-list d-flex">
                        <li>{offer.business_unit}</li>
                    </ul>
                </LocaleLink>
            </>
        )
    }
}

export default TinyJobCard;
